import { render, staticRenderFns } from "./PointDisbursementReport.vue?vue&type=template&id=5f5ad228&"
import script from "./PointDisbursementReport.vue?vue&type=script&lang=js&"
export * from "./PointDisbursementReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports